import { createContext, useContext, useEffect, type Dispatch, type SetStateAction } from "react";
import { useLocation } from "react-router-dom";

export type BusinessPageTitle = { pathname: string; title: string };

export const BusinessPageTitleContext = createContext<Dispatch<SetStateAction<BusinessPageTitle | null>> | null>(null);

/** 将已加载业务名称提供给后台页签与浏览器标题。 */
export function useBusinessPageTitle(title: string | undefined): void {
  const setTitle = useContext(BusinessPageTitleContext);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!setTitle || !title?.trim()) return;
    const registration = { pathname, title: title.trim() };
    setTitle(registration);
    return () => setTitle((current) => current === registration ? null : current);
  }, [pathname, setTitle, title]);
}
